import { defineMessages } from 'react-intl';

export default defineMessages({
	select: {
		id: 'register.ethnicity.select',
		defaultMessage: `-- select an option --`,
	},
	american_indian: {
		id: 'register.ethnicity.american_indian',
		defaultMessage: `American Indian or Alaska Native`,
	},
	african_american: {
		id: 'register.ethnicity.african_american',
		defaultMessage: `African American or Black`,
	},
	asian_indian: {
		id: 'register.ethnicity.asian_indian',
		defaultMessage: `Asian`,
	},
	latino: {
		id: 'register.ethnicity.latino',
		defaultMessage: `Latino / Hispanic`,
	},
	middle_eastern: {
		id: 'register.ethnicity.middle_eastern',
		defaultMessage: `Middle Eastern`,
	},
	pacific_islander: {
		id: 'register.ethnicity.pacific_islander',
		defaultMessage: `Native Hawaiian or Other Pacific Islander`,
	},
	white: {
		id: 'register.ethnicity.white',
		defaultMessage: `Caucasian or White`,
	},
	other: {
		id: 'register.ethnicity.other',
		defaultMessage: `Other`,
	},
	decline: {
		id: 'register.ethnicity.decline',
		defaultMessage: `Prefer not to answer`,
	},
});




// WEBPACK FOOTER //
// ./src/locales/ethnicity.js